// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1HMNK","box":"WorkspacesBox_box__28KsI","node":"WorkspacesBox_node__3CEVf"};